import { IApiPartner, IPartner } from './interface/IPartner'

export const partnerTransformer = (apiPartner: IApiPartner): IPartner => ({
  ...apiPartner,
  firstName: apiPartner.first_name,
  lastName: apiPartner.last_name,
  pipedriveId: apiPartner.pipedrive_id
})
